// extracted by mini-css-extract-plugin
export default {"checkbox":"custom-checkbox_checkbox__njjlN","chButton":"custom-checkbox_chButton__8Qn4K","chTrue":"custom-checkbox_chTrue__5Yivk"};